import SegmentClient from "clients/SegmentClient";

export const successfulLeadSubmission = () => {
  SegmentClient.trackEvent({
    event: "postcode need submitted",
    eventCategory: "user aquisition - postcode search",
    eventAction: "postcode need submitted",
    eventLabel: "submit"
  });
};

export const failedLeadFormSubmission = () => {
  SegmentClient.trackEvent({
    event: "conversational form failed submission",
    eventCategory: "pre-user activation",
    eventAction: "conversational form failed submission",
    eventLabel: "submit"
  });
};

export const carePageSubmitted = () => {
  SegmentClient.trackEvent({
    event: "postcode basic details submit",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode basic details submit",
    eventLabel: "submit"
  });
};

export const phonePageSubmitted = () => {
  SegmentClient.trackEvent({
    event: "postcode phone number details submit",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode phone number details submit",
    eventLabel: "submit"
  });
};

export const paginatedFormSubmit = () => {
  SegmentClient.trackEvent({
    event: "postcode paginated form submit",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode paginated form submit",
    eventLabel: "submit"
  });
};

export const standardFormSubmit = () => {
  SegmentClient.trackEvent({
    event: "postcode standard form submit",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode standard form submit",
    eventLabel: "submit"
  });
};

export const formTriggeredByScroll = () => {
  SegmentClient.trackEvent({
    event: "postcode form scroll trigger",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode form scroll trigger",
    eventLabel: "scroll"
  });
};

export const emailDetailsSubmit = () => {
  SegmentClient.trackEvent({
    event: "postcode email details click",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode email details click",
    eventLabel: "click"
  });
};

export const phoneDetailsSubmit = () => {
  SegmentClient.trackEvent({
    event: "postcode phone number details click",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode phone number details click",
    eventLabel: "click"
  });
};

export const basicDetailsSubmit = () => {
  SegmentClient.trackEvent({
    event: "postcode basic details click",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode basic details click",
    eventLabel: "click"
  });
};

export const postcodeAdUnitClick = () => {
  SegmentClient.trackEvent({
    event: "postcode ad unit click",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode ad unit click",
    eventLabel: "click"
  });
};

export const carerCardClick = () => {
  SegmentClient.trackEvent({
    event: "postcode carer card click",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode carer card click",
    eventLabel: "click"
  });
};

export const postcodeCtaClick = () => {
  SegmentClient.trackEvent({
    event: "postcode search banner click",
    eventCatergory: "user aquisition - postcode search",
    eventAction: "postcode search banner click",
    eventLabel: "click"
  });
};
